<div class="container">
  <div class="boards-header">
    <div class="row">
      <div class="col-md-6">
        <div class="select-by-client-row" *ngIf="clientOptions.length > 0">
          <select
            class="form-control select-by-client"
            [(ngModel)]="selectedClientFilter"
            (ngModelChange)="onSelectAllByClient($event)"
            aria-label="Select all scheduling teams by client"
            title="Select all scheduling teams for the chosen client"
          >
            <option [ngValue]="null">Select all by client...</option>
            <option *ngFor="let c of clientOptions" [ngValue]="c.id">{{ c.name }}</option>
          </select>
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary clear-selection-btn"
            (click)="clearTeamSelection()"
            [disabled]="selectedTeamIds.size === 0"
            title="Clear team selection"
          >
            <i class="fa fa-times"></i> Clear
          </button>
        </div>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="searchText"
          (ngModelChange)="filterSchedulingTeams()"
          placeholder="Search scheduling teams..."
          aria-label="Search scheduling teams"
        />
      </div>
      <div class="col-md-6 text-right">
        <button
          class="btn btn-info email-drivers-btn"
          (click)="openEmailModal()"
          [disabled]="emailDriverCount === 0"
          title="Email all drivers on the selected scheduling teams"
        >
          <i class="fa fa-envelope"></i> Email Drivers ({{ emailDriverCount }})
        </button>
        <button *ngIf="canEdit" class="btn btn-primary" (click)="openAddModal()">
          <i class="fa fa-plus"></i> Add
        </button>
      </div>
    </div>
  </div>

  <div class="boards-list" *ngIf="!isLoading && filteredSchedulingTeams.length > 0">
    <div
      class="board-card"
      *ngFor="let schedulingTeam of filteredSchedulingTeams"
      [class.selected]="isTeamSelected(schedulingTeam.id!)"
    >
      <div class="board-header" (click)="toggleSchedulingTeamExpansion(schedulingTeam.id!)">
        <div class="board-header-left">
          <input
            type="checkbox"
            class="team-select-checkbox"
            [checked]="isTeamSelected(schedulingTeam.id!)"
            (click)="$event.stopPropagation()"
            (change)="toggleSelectTeam(schedulingTeam.id!)"
            title="Select scheduling team for emailing"
            [attr.aria-label]="'Select ' + schedulingTeam.name"
          />
          <i
            class="fa"
            [ngClass]="
              isSchedulingTeamExpanded(schedulingTeam.id!) ? 'fa-chevron-down' : 'fa-chevron-right'
            "
          ></i>
          <span class="board-name" [innerHTML]="highlightText(schedulingTeam.name)"></span>
          <span class="board-client" *ngIf="schedulingTeam.clientName"
            >- {{ schedulingTeam.clientName }}</span
          >
          <span class="board-stats"
            ><span class="stat-badge driver-badge"
              ><i class="fa fa-user"></i> {{ schedulingTeam.drivers.length }} Driver{{
                schedulingTeam.drivers.length !== 1 ? "s" : ""
              }}</span
            ><span
              class="stat-badge non-driver-badge"
              *ngIf="schedulingTeam.membersAreNonDrivers"
              title="Members are non-drivers - excluded from the Driver Check"
              ><i class="fa fa-user-o"></i> Non-drivers</span
            ></span
          >
        </div>
        <div class="board-header-right" *ngIf="canEdit">
          <button
            class="btn-icon"
            (click)="openEditModal(schedulingTeam); $event.stopPropagation()"
            title="Edit Scheduling Team"
          >
            <i class="fa fa-pencil"></i>
          </button>
          <button
            class="btn-icon btn-danger"
            (click)="deleteSchedulingTeam(schedulingTeam); $event.stopPropagation()"
            title="Delete Scheduling Team"
          >
            <i class="fa fa-trash"></i>
          </button>
        </div>
      </div>

      <div class="board-body" *ngIf="isSchedulingTeamExpanded(schedulingTeam.id!)">
        <div
          class="board-section"
          *ngIf="schedulingTeam.contacts && schedulingTeam.contacts.length > 0"
        >
          <h5>Contacts</h5>
          <div class="contacts-list">
            <div class="contact-row" *ngFor="let contact of schedulingTeam.contacts">
              <div class="contact-name">
                <strong [innerHTML]="highlightText(contact.name)"></strong
                ><span
                  class="contact-role"
                  *ngIf="contact.role"
                  [innerHTML]="highlightText('(' + contact.role + ')')"
                ></span>
              </div>
              <div class="contact-email" *ngIf="contact.email">
                <i class="fa fa-envelope"></i> <span>Email: {{ contact.email }}</span>
              </div>
              <div class="contact-phone" *ngIf="contact.phone">
                <i class="fa fa-phone"></i> <span>Phone: {{ contact.phone | phoneNumber }}</span>
              </div>
              <div class="contact-do-not-contact" *ngIf="contact.doNotContact">
                ⚠️ Do Not Contact
              </div>
            </div>
          </div>
        </div>
        <div
          class="board-section"
          *ngIf="schedulingTeam.boards && schedulingTeam.boards.length > 0"
        >
          <h5>Boards</h5>
          <div class="board-options-list">
            <div class="board-option-item" *ngFor="let board of schedulingTeam.boards">
              <i class="fa fa-tag"></i> <span [innerHTML]="highlightText(board.name)"></span>
            </div>
          </div>
        </div>
        <div
          class="board-section"
          *ngIf="schedulingTeam.drivers && schedulingTeam.drivers.length > 0"
        >
          <h5>Drivers</h5>
          <div class="drivers-list">
            <div class="driver-item" *ngFor="let d of schedulingTeam.drivers">
              <div class="driver-info">
                <i class="fa fa-user"></i>
                <span [innerHTML]="highlightText(d.name + ' ' + d.lastName)"></span
                ><span class="text-muted" *ngIf="d.driverNo">({{ d.driverNo }})</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="loading-spinner" *ngIf="isLoading">
    <i class="fa fa-spinner fa-spin"></i> Loading scheduling teams...
  </div>
  <div class="no-boards" *ngIf="!isLoading && filteredSchedulingTeams.length === 0">
    <i class="fa fa-clipboard"></i>
    <p>No scheduling teams found</p>
  </div>
</div>

<p-dialog
  [(visible)]="showAddModal"
  [header]="'Add Scheduling Team'"
  [modal]="true"
  [style]="{ width: '700px' }"
  [draggable]="false"
  [resizable]="false"
>
  <div class="modal-body">
    <div class="form-group">
      <label>Scheduling Team Name <span class="text-danger">*</span></label
      ><input
        type="text"
        class="form-control"
        [(ngModel)]="newSchedulingTeam.name"
        placeholder="Enter scheduling team name"
        aria-label="Scheduling team name"
      />
    </div>
    <div class="form-group">
      <label>Client (optional)</label
      ><select class="form-control" [(ngModel)]="selectedClientId">
        <option [ngValue]="null">-- No Client --</option>
        <option *ngFor="let c of clients" [ngValue]="c.id">{{ c.companyName }}</option>
      </select>
    </div>
    <div class="form-group">
      <label
        class="checkbox-label"
        title="Members are not drivers (office staff etc.), so they are left out of the Driver Check on the dispatch dashboard."
        ><input
          type="checkbox"
          [(ngModel)]="newSchedulingTeam.membersAreNonDrivers"
          aria-label="Members are non-drivers"
        />
        Members are non-drivers (excluded from Driver Check)</label
      >
    </div>
    <div class="form-group">
      <label>Boards</label>
      <div class="items-list">
        <div
          *ngFor="let boardName of selectedBoardNames; let i = index; trackBy: trackByIndex"
          class="item-row"
        >
          <input
            type="text"
            class="form-control"
            [(ngModel)]="selectedBoardNames[i]"
            placeholder="Enter board name"
            aria-label="Board name"
          /><button class="btn btn-sm btn-remove" (click)="removeNewBoard(i)">
            <i class="fa fa-minus"></i>
          </button>
        </div>
        <button class="btn btn-secondary btn-add" (click)="addNewBoard()">
          <i class="fa fa-plus"></i> Add Board
        </button>
      </div>
    </div>
    <div class="form-group">
      <label>Contacts</label>
      <div class="items-list">
        <div
          *ngFor="let contact of selectedContacts; let i = index; trackBy: trackByIndex"
          class="contact-form-row"
        >
          <div class="contact-form-vertical">
            <div class="form-field-full">
              <label class="field-label">Name <span class="text-danger">*</span></label
              ><input
                type="text"
                class="form-control"
                [ngClass]="{ 'is-invalid': newContactErrors[i] }"
                [(ngModel)]="selectedContacts[i].name"
                (ngModelChange)="clearContactNameError(i, 'new')"
                placeholder="Enter contact name"
                aria-label="Contact name"
              />
              <div *ngIf="newContactErrors[i]" class="text-danger d-block">
                {{ newContactErrors[i] }}
              </div>
            </div>
            <div class="form-field-full">
              <label class="field-label">Email</label
              ><input
                type="email"
                class="form-control"
                [(ngModel)]="selectedContacts[i].email"
                placeholder="Enter email address"
                aria-label="Contact email"
              />
            </div>
            <div class="form-field-full">
              <label class="field-label">Phone</label
              ><input
                type="tel"
                class="form-control"
                [(ngModel)]="selectedContacts[i].phone"
                placeholder="Enter phone number"
                aria-label="Contact phone"
              />
            </div>
            <div class="form-field-full">
              <label class="field-label">Role</label
              ><input
                type="text"
                class="form-control"
                [(ngModel)]="selectedContacts[i].role"
                placeholder="Enter role/title"
                aria-label="Contact role"
              />
            </div>
            <div class="form-field-full checkbox-field">
              <label class="checkbox-label"
                ><input
                  type="checkbox"
                  [(ngModel)]="selectedContacts[i].doNotContact"
                  aria-label="Do not contact"
                />
                Do Not Contact</label
              >
            </div>
          </div>
          <button
            class="btn btn-sm btn-remove"
            (click)="removeNewContact(i)"
            title="Remove Contact"
          >
            <i class="fa fa-minus"></i>
          </button>
        </div>
        <button class="btn btn-secondary btn-add" (click)="addNewContact()">
          <i class="fa fa-plus"></i> Add Contact
        </button>
      </div>
    </div>
  </div>
  <p-footer
    ><div class="button-group">
      <button class="btn btn-secondary" (click)="closeAddModal()">Cancel</button
      ><button class="btn btn-primary" (click)="createSchedulingTeam()">
        Create Scheduling Team
      </button>
    </div></p-footer
  >
</p-dialog>

<p-dialog
  [(visible)]="showEditModal"
  [header]="'Edit Scheduling Team'"
  [modal]="true"
  [style]="{ width: '700px' }"
  [draggable]="false"
  [resizable]="false"
>
  <div class="modal-body" *ngIf="editingSchedulingTeam">
    <div class="form-group">
      <label>Scheduling Team Name <span class="text-danger">*</span></label
      ><input
        type="text"
        class="form-control"
        [(ngModel)]="editingSchedulingTeam.name"
        placeholder="Enter scheduling team name"
        aria-label="Scheduling team name"
      />
    </div>
    <div class="form-group">
      <label
        class="checkbox-label"
        title="Members are not drivers (office staff etc.), so they are left out of the Driver Check on the dispatch dashboard."
        ><input
          type="checkbox"
          [(ngModel)]="editingSchedulingTeam.membersAreNonDrivers"
          aria-label="Members are non-drivers"
        />
        Members are non-drivers (excluded from Driver Check)</label
      >
    </div>
    <div class="form-group">
      <label>Boards</label>
      <div class="items-list">
        <div
          *ngFor="let boardName of editSelectedBoardNames; let i = index; trackBy: trackByIndex"
          class="item-row"
        >
          <input
            type="text"
            class="form-control"
            [(ngModel)]="editSelectedBoardNames[i]"
            placeholder="Enter board name"
            aria-label="Board name"
          /><button class="btn btn-sm btn-remove" (click)="removeEditBoard(i)">
            <i class="fa fa-minus"></i>
          </button>
        </div>
        <button class="btn btn-secondary btn-add" (click)="addEditBoard()">
          <i class="fa fa-plus"></i> Add Board
        </button>
      </div>
    </div>
    <div class="form-group">
      <label>Contacts</label>
      <div class="items-list">
        <div
          *ngFor="let contact of editSelectedContacts; let i = index; trackBy: trackByIndex"
          class="contact-form-row"
        >
          <div class="contact-form-vertical">
            <div class="form-field-full">
              <label class="field-label">Name <span class="text-danger">*</span></label
              ><input
                type="text"
                class="form-control"
                [ngClass]="{ 'is-invalid': editContactErrors[i] }"
                [(ngModel)]="editSelectedContacts[i].name"
                (ngModelChange)="clearContactNameError(i, 'edit')"
                placeholder="Enter contact name"
                aria-label="Contact name"
              />
              <div *ngIf="editContactErrors[i]" class="text-danger d-block">
                {{ editContactErrors[i] }}
              </div>
            </div>
            <div class="form-field-full">
              <label class="field-label">Email</label
              ><input
                type="email"
                class="form-control"
                [(ngModel)]="editSelectedContacts[i].email"
                placeholder="Enter email address"
                aria-label="Contact email"
              />
            </div>
            <div class="form-field-full">
              <label class="field-label">Phone</label
              ><input
                type="tel"
                class="form-control"
                [(ngModel)]="editSelectedContacts[i].phone"
                placeholder="Enter phone number"
                aria-label="Contact phone"
              />
            </div>
            <div class="form-field-full">
              <label class="field-label">Role</label
              ><input
                type="text"
                class="form-control"
                [(ngModel)]="editSelectedContacts[i].role"
                placeholder="Enter role/title"
                aria-label="Contact role"
              />
            </div>
            <div class="form-field-full checkbox-field">
              <label class="checkbox-label"
                ><input
                  type="checkbox"
                  [(ngModel)]="editSelectedContacts[i].doNotContact"
                  aria-label="Do not contact"
                />
                Do Not Contact</label
              >
            </div>
          </div>
          <button
            class="btn btn-sm btn-remove"
            (click)="removeEditContact(i)"
            title="Remove Contact"
          >
            <i class="fa fa-minus"></i>
          </button>
        </div>
        <button class="btn btn-secondary btn-add" (click)="addEditContact()">
          <i class="fa fa-plus"></i> Add Contact
        </button>
      </div>
    </div>
  </div>
  <p-footer
    ><div class="button-group">
      <button class="btn btn-secondary" (click)="closeEditModal()">Cancel</button
      ><button class="btn btn-primary" (click)="updateSchedulingTeam()">Save Changes</button>
    </div></p-footer
  >
</p-dialog>

<!-- Email Compose Modal -->
<p-dialog
  [(visible)]="showEmailModal"
  [modal]="true"
  [style]="{ width: '700px' }"
  header="EMAIL DRIVERS"
  [closable]="false"
  styleClass="email-compose-dialog"
>
  <div class="modal-body">
    <div class="form-group">
      <label><strong>TO:</strong></label>
      <textarea
        class="form-control"
        [ngClass]="{ 'is-invalid': emailValidationErrors.to }"
        [(ngModel)]="emailCompose.to"
        (ngModelChange)="clearEmailValidationError('to')"
        rows="3"
        placeholder="SEPARATE MULTIPLE EMAILS WITH SEMICOLONS"
      ></textarea>
      <div *ngIf="emailValidationErrors.to" class="text-danger d-block">
        {{ emailValidationErrors.to }}
      </div>
    </div>

    <div class="form-group">
      <label><strong>CC:</strong></label>
      <input
        type="text"
        class="form-control"
        [ngClass]="{ 'is-invalid': emailValidationErrors.cc }"
        [(ngModel)]="emailCompose.cc"
        (ngModelChange)="clearEmailValidationError('cc')"
        placeholder="SEPARATE MULTIPLE EMAILS WITH SEMICOLONS"
      />
      <div *ngIf="emailValidationErrors.cc" class="text-danger d-block">
        {{ emailValidationErrors.cc }}
      </div>
    </div>

    <div class="form-group">
      <label><strong>SUBJECT:</strong> <span class="text-danger">*</span></label>
      <input
        type="text"
        class="form-control"
        [ngClass]="{ 'is-invalid': emailValidationErrors.subject }"
        [(ngModel)]="emailCompose.subject"
        (ngModelChange)="clearEmailValidationError('subject')"
      />
      <div *ngIf="emailValidationErrors.subject" class="text-danger d-block">
        {{ emailValidationErrors.subject }}
      </div>
    </div>

    <div class="form-group">
      <label><strong>MESSAGE:</strong> <span class="text-danger">*</span></label>
      <textarea
        class="form-control"
        [ngClass]="{ 'is-invalid': emailValidationErrors.body }"
        [(ngModel)]="emailCompose.body"
        (ngModelChange)="clearEmailValidationError('body')"
        rows="12"
      ></textarea>
      <div *ngIf="emailValidationErrors.body" class="text-danger d-block">
        {{ emailValidationErrors.body }}
      </div>
    </div>

    <div class="form-group">
      <label><strong>ATTACHMENTS:</strong></label>
      <div class="attachment-upload">
        <input
          type="file"
          #emailFileInput
          multiple
          (change)="onFilesSelected($event)"
          style="display: none"
        />
        <button
          type="button"
          class="btn btn-outline-secondary btn-sm"
          (click)="emailFileInput.click()"
        >
          <i class="fa fa-paperclip"></i> ADD FILES
        </button>
        <span class="attachment-hint">ANY FILE TYPE</span>
      </div>
      <div *ngIf="emailAttachments.length > 0" class="attachment-list">
        <div *ngFor="let file of emailAttachments; let i = index" class="attachment-item">
          <i class="fa fa-file-o"></i>
          <span class="attachment-name">{{ file.name }}</span>
          <span class="attachment-size">({{ formatFileSize(file.size) }})</span>
          <button type="button" class="btn-remove-attachment" (click)="removeAttachment(i)">
            <i class="fa fa-times"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <p-footer>
    <div class="button-group">
      <button class="btn btn-secondary" (click)="cancelEmailModal()">CANCEL</button>
      <button
        class="btn btn-primary"
        (click)="confirmSendEmail()"
        [disabled]="!emailCompose.to || isSendingEmail"
      >
        <i class="fa fa-paper-plane"></i> SEND EMAIL
      </button>
    </div>
  </p-footer>
</p-dialog>
